<!-- 人员管理总页面 -->
<template>
  <div class="app-container permission-manage">
    <div class="top-search">
      <header class="search-title">
        <span class="title-text">人员管理</span>
      </header>
      <div class="search-condition">
        <el-form ref="form" :model="searchForm" label-width="95px">
          <div class="search-content">
            <div class="left-content">
              <el-form-item label="账号名称：">
                <el-input
                  v-model="searchForm.FUserName"
                  placeholder="请输入账号名称"
                />
              </el-form-item>
              <el-form-item label="手机号：">
                <el-input
                  v-model="searchForm.FPhone"
                  placeholder="请输入手机号"
                />
              </el-form-item>
              <el-form-item label="部门：">
                <el-input
                  v-model="searchForm.FTreeName"
                  clearable
                  placeholder="请选择部门"
                  @clear="clearDeparent"
                >
                  <i slot="suffix" class="el-icon-menu" @click="selectDeparment(true)" />
                </el-input>
              </el-form-item>
              <el-form-item label="账号状态：">
                <el-select v-model="searchForm.FAccepted" placeholder="请选择">
                  <el-option
                    v-for="item in numOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="岗位：">
                <el-input
                  v-model="searchForm.FRoleName"
                  placeholder="请输入岗位"
                />
              </el-form-item>
            </div>
            <el-row style="padding-left:10px;" :gutter="24">
              <el-button v-if="rols('新增')" style="width:77px;" class="operation_btn" @click="addNewPermission(1)">
                新增
              </el-button>
              <el-button class="operation_btn" @click="batchOperation(0)">
                批量启用
              </el-button>
              <el-button class="operation_btn" @click="batchOperation(1)">
                批量禁用
              </el-button>
              <el-button @click="currentPage = 1 , onSearch()">查询</el-button>
            </el-row>
          </div>
        </el-form>
      </div>
      <div class="permission-bottom-table">
        <el-table
          ref="multipleTable"
          v-loading="tableLoading"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          fit
          :header-cell-style="{background:'#F2F2F8 ',color:'#797E8D',fontSize:'14px',height:'36px'}"
          :row-style="{fontSize:'16px'}"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            v-if="isBatch"
            :key="checkKey"
            width="55"
            align="center"
          >
            <template slot="header">
              <el-checkbox v-model="allCheck" :disabled="allDisable" :indeterminate="isIndeterminate" @change="allChange" />
            </template>
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.check" :disabled="scope.row.FAccepted !== operateType" @change="itemChange" />
            </template>
          </el-table-column>
          <el-table-column
            label="序号"
            type="index"
            width="90"
            align="center"
          />
          <el-table-column prop="fname" label="账号名称" show-overflow-tooltip width="250">
            <template slot-scope="scope">
              {{ scope.row.FUserName }}<span v-if="scope.row.FType === 1" class="administrator">管理员</span>
            </template>
          </el-table-column>
          <el-table-column prop="FPhone" label="手机号" show-overflow-tooltip />
          <el-table-column prop="FName" label="所属部门" show-overflow-tooltip width="350" />
          <el-table-column prop="FRoleName" label="工作岗位" show-overflow-tooltip />
          <el-table-column prop="FCreator" label="创建人" show-overflow-tooltip />
          <el-table-column prop="FAcceptTime" label="创建时间" show-overflow-tooltip width="110" />
          <el-table-column label="操作" width="150" align="center">
            <template slot-scope="scope">
              <div class="bottom-operation">
                <span v-if="rols('修改')" @click="addNewPermission(2,scope.row)">
                  <i class="el-icon-edit" />
                </span>
                <span>
                  <el-switch
                    v-model="scope.row.FAccepted"
                    active-color="#EC212D"
                    inactive-color="#dcdfe6"
                    :active-value="1"
                    :inactive-value="0"
                    @change="validAndDelete(scope.row.FID,scope.row.FAccepted ? 0 : 1,scope.row)"
                  />
                </span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page="currentPage"
          :page-sizes="[50, 100, 500]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
    <newPermission :edit-fid="editFid" :add-visible="addVisible" :title="title" @onSearch="onSearch" @addSwitch="addSwitch" />
    <treeSearch
      parent-id="FParentID"
      label="FName"
      fid="FID"
      :tree-visible="treeVisible"
      search-url="/mall/mallmanage/demanduserdepart/queryAllDemanduserdepart"
      :default-arr="defaultArr"
      @treeConfirm="treeConfirm"
      @treeClose="selectDeparment"
    />
  </div>
</template>

<script>
import service from '@/utils/request'
import newPermission from './newPermission.vue'
import treeSearch from '@/components/tree/tree.vue'
export default {
  components: {
    newPermission,
    treeSearch
  },
  data() {
    return {
      allDisable: true,
      allCheck: false,
      isIndeterminate: false,
      operateType: null,
      isBatch: false,
      numOptions: [
        {
          value: -1,
          label: '全部'
        },
        {
          value: 1,
          label: '启用'
        },
        {
          value: 0,
          label: '禁用'
        }
      ],
      options: [{
        value: -1,
        label: '全部'
      }, {
        value: 1,
        label: '有效'
      }, {
        value: 0,
        label: '无效'
      }],
      tipsType: null,
      editFid: null,
      treeVisible: false,
      tipsData: {},
      tipsArr: [
        {
          title: '删除',
          svgClass: 'depart-delete',
          text: '确认删除该人员吗？'
        },
        {
          title: '无法删除',
          svgClass: 'depart-nodelete',
          text: '该人员已有效无法删除！'
        },
        {
          title: '有效确认',
          svgClass: 'new-validCfm',
          text: '确认有效该人员吗？'
        },
        {
          title: '确认弹窗',
          svgClass: 'new-valid',
          text: '该人员已有效！'
        }
      ],
      title: '新增人员',
      addVisible: false,
      tableLoading: true,
      currentPage: 1,
      pageSize: 50,
      total: 0,
      searchForm: {
        FUserName: '',
        FPhone: '',
        FTreeCode: '',
        FTreeName: '',
        FRoleName: '',
        FAccepted: 1
      },
      tableData: [],
      selectIds: '',
      selectArr: [],
      defaultArr: [],
      checkKey: 0
    }
  },
  computed: {
    // 当前页操作权限
    rols() {
      const setting = this.$store.getters.pageSetting('人员管理')
      return function(val) {
        if (typeof setting === 'boolean') return true
        return setting.indexOf(val) > -1
      }
    }
  },
  created() {
    this.onSearch()
  },
  methods: {
    allChange(val) {
    //   this.allCheck = val
      let n
      if (this.isIndeterminate) {
        let a = 0
        let b = 0
        this.tableData.forEach(t => {
          if (t.FAccepted === this.operateType) a++
          if (t.check) b++
        })
        n = !(a === b)
      } else if (this.allCheck) {
        n = true
      } else {
        n = false
      }
      this.tableData.forEach(t => {
        if (t.FAccepted === this.operateType) {
          t.check = n
        }
      })
      this.itemChange()
    },
    itemChange() {
      let n = 0
      this.tableData.forEach(t => {
        if (t.check) n++
      })
      if (n) {
        if (n != this.tableData.length) {
          this.isIndeterminate = true
          this.allCheck = false
        } else {
          this.isIndeterminate = false
          this.allCheck = true
        }
      } else {
        this.isIndeterminate = false
        this.allCheck = false
      }
      this.checkKey++
    },
    handleSelectionChange(val) {
      this.selectArr = val
    },
    batchOperation(n) {
      const i = this.tableData.findIndex(t => t.FAccepted == n)
      this.allDisable = i == -1
      this.checkKey++
      if (this.isBatch && this.operateType === n) {
        if (this.isIndeterminate || this.allCheck) {
          const idArr = []
          this.tableData.forEach(t => {
            if (t.check) idArr.push(t.FID)
          })
          const ids = idArr.toString()
          this.validAndDelete(ids, this.operateType)
        } else {
          this.isIndeterminate = false
          this.isBatch = false
          this.operateType = null
        }
      } else if (this.isBatch && this.operateType !== n) {
        this.isIndeterminate = false
        this.operateType = n
        this.allCheck = false
        this.isIndeterminate = false
        this.tableData.forEach(t => {
          t.check = false
        })
      } else if (!this.isBatch) {
        this.isIndeterminate = false
        this.isBatch = true
        this.operateType = n
      }
    },
    validAndDelete(ids, type, row) {
      this.tableLoading = true
      const url = !type
        ? `/mall/mallmanage/demanduserdepart/acceptDemanduser/${ids}`
        : `/mall/mallmanage/demanduserdepart/deleteDemanduser/${ids}`
      const method = !type ? 'get' : 'delete'
      service({
        url,
        method
      })
        .then(res => {
          if (res.result) {
            this.tableLoading = false
            if (!type && res.data.existMsg) {
              this.$notify.warning(res.data.existMsg)
            } else if (!type && !res.data.existMsg) {
              this.$message.success('启用人员成功!')
            } else {
              this.$message.success(res.msg)
            }

            if (row && !res.data.existMsg) {
              row.FAccepted = type ? 0 : 1
              if (this.operateType === type) {
                row.check = false
              }
              this.itemChange()
              const i = this.tableData.findIndex(t => t.FAccepted == this.operateType)
              this.allDisable = i == -1
            } else {
              this.onSearch()
              this.isBatch = false
            }
          } else {
            this.tableLoading = false
            this.$message.error(res.msg)
          }
        })
        .catch(() => {
          this.tableLoading = false
        })
    },
    onSearch() {
      this.allCheck = false
      this.isIndeterminate = false
      this.tableLoading = true
      const params = new URLSearchParams()
      const jsonStr = JSON.parse(JSON.stringify(this.searchForm))
      delete jsonStr.FTreeName
      params.append('jsonStr', JSON.stringify(jsonStr))
      params.append('pageNo', this.currentPage)
      params.append('pageSize', this.pageSize)
      service({
        url: '/mall/mallmanage/demanduserdepart/queryDemanduserdepart',
        method: 'post',
        params
      })
        .then(res => {
          res.data.records && (res.data.records.forEach(t => {
            this.$set(t, 'check', false)
          }))
          this.tableData = res.data.records
          const i = this.tableData.findIndex(t => t.FAccepted === this.operateType)
          this.allDisable = i == -1
          this.checkKey++
          this.total = res.data.total
          this.tableLoading = false
        })
        .catch(() => {
          this.tableLoading = false
        })
    },
    treeConfirm(val) {
      this.searchForm.FTreeCode = val ? val.FTreeCode : ''
      this.searchForm.FTreeName = val ? val.FName : ''
      this.selectDeparment(false)
    },
    clearDeparent() {
      this.searchForm.FTreeCode = this.searchForm.FTreeName = ''
    },
    selectDeparment(val) {
      this.treeVisible = val
    },
    addNewPermission(val, row) {
      if (val === 1) {
        this.title = '新增人员'
        this.editFid = null
      } else if (val === 2) {
        this.title = '修改人员'
        this.editFid = row.FID
      }
      this.addVisible = true
    },
    addSwitch() {
      this.editFid = null
      this.addVisible = false
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.onSearch()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.onSearch()
    }
  }
}
</script>

<style lang="scss" scoped>
.app-container {
  background: #ffffff;
  padding: 8px 15px;
  height: 100%;
  display: flex;
  flex-direction: column;
      .permission-bottom-table {
          .validStatus {
              display: inline-block;
              width: 8px;
              height: 8px;
              background-color: #EC212D;
              border-radius: 50%;
              margin-right: 6px;
              color: #EC212D;
          }
          .invalid {
              background-color: #C3C5CC;
          }
          .administrator {
              margin: -2px 0 0 15px;
              display: inline-block;
              width: 49px;
              height: 21px;
              border-radius: 2px;
              background-color: #FFE5E5;
              font-size: 12px;
              color: #FF6161;
              text-align: center;
          }
          .onTheJob {
              margin-left: 0;
              border: 1px solid #FFACB1;
          }
          .quit {
              margin-left: 0;
              border: 1px solid #D7DAE5;
              background: #E7E9EF;
              color: #B3B6C5;
          }
        .bottom-operation {
            display: flex;
            color: #EC212D;
            span {
                display: inline-block;
                width: 50%;
                cursor: pointer;
                text-align: center;
            }
        }
    }
  .iconBox {
    width: 35px;
    height: 35px;
  }
  .commodity-form {
    display: flex;
    margin: 17px 10px;
    .first-button {
      background-color: #ec212d;
      color: #fff;
    }
  }
  .search-title {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 40px;
    line-height: 40px;
    background-color: #ec212d;
    .title-text {
      color: #fff;
      font-size: 20px;
      margin-left: 11px;
    }
  }
  .top-search {
    width: 100%;
    display: flex;
    flex-direction: column;
    .search-condition {
        margin-top: 20px;
        font-size: 16px;
        color: #8C909C;
        .search-content {
            position: relative;
            width: 100%;
            .left-content {
                display: flex;
                .el-form-item {
                    flex: 1;
                }
            }
        }
        span {
            display: inline-block;
            width: 65px;
            height: 40px;
            line-height: 40px;
        }
        .operation_btn {
            width: 125px;
            height: 40px;
            background: #FFFFFF;
            border-radius: 4px;
            border: 1px solid #EC212D;
            color: #EC212D;
        }
    }
  }
  .bottom-table {
    height: 88%;
  }
  .operation-icon {
    width: 16px;
    height: 16px;
    margin-right: 15px;
    cursor: pointer;
  }
  .one-icon {
    width: 16px;
    height: 16px;
    cursor: pointer;
  }
}
</style>
<style lang="scss">
.el-loading-mask.is-fullscreen {
        z-index: 999999 !important;
    }
.search-condition {
    // .el-input {
    //     width: 240px;
    // }
    .el-form-item {
        margin-bottom: 20px;
    }
    .el-input__inner {
        height: 40px !important;
    }
    .el-input__suffix {
        right: 10px;
        line-height: 40px;
    }
    .el-button {
        position: relative;
        width: 77px;
        height: 40px;
        font-size: 16px;
        background: #EC212D;
        border-radius: 4px 4px 4px 4px;
        color: #fff;
        span {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
        }
    }
}
.permission-bottom-table {
    margin-top: 20px;
    .el-pagination {
        display: flex;
        justify-content: right;
        align-items: center;
        height: 65px;
    }
    .el-table__body-wrapper {
       height: 450px;
       overflow-y: auto;
    }
}
</style>
